/**
 * Columns the responsive asset grid shows at a viewport width. Mirrors the breakpoint classes of `AssetGrid`
 * (`grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-7`).
 */
function getResponsiveGridColumns(viewportWidth: number): number {
  if (viewportWidth < 640) return 2;
  if (viewportWidth < 768) return 3;
  if (viewportWidth < 1024) return 4;
  if (viewportWidth < 1280) return 5;
  if (viewportWidth < 1536) return 6;
  return 7;
}

const MIN_LOAD_COUNT = 12;
const MAX_LOAD_COUNT = 50;
const BUFFER_ROWS = 2;

/**
 * How many assets the first page of a grid should load so it fills the viewport with a couple of rows to spare.
 *
 * @param columns Columns the grid renders. Defaults to the responsive column count for the current viewport; pass it
 * when the user picked a fixed number of images per row.
 */
function calculateOptimalLoadCount(columns: number = getResponsiveGridColumns(window.innerWidth)): number {
  const estimatedCardWidth = window.innerWidth / columns;
  // Some buffer
  const estimatedCardHeight = estimatedCardWidth * 1.2;

  const availableHeight = window.innerHeight * 0.8;
  const rowsNeeded = Math.ceil(availableHeight / estimatedCardHeight);

  const calculatedCount = (rowsNeeded + BUFFER_ROWS) * columns;

  return Math.max(MIN_LOAD_COUNT, Math.min(MAX_LOAD_COUNT, calculatedCount));
}

export { calculateOptimalLoadCount, getResponsiveGridColumns };
